export default {
	transaction_currency_table_order_id: 'Order ID',
	transaction_currency_table_created_at: 'Timestamp',
	transaction_currency_table_type: 'Type',
	transaction_currency_table_amount: 'Amount',
	transaction_currency_table_fee: 'Fee',
	transaction_currency_table_amount_total: 'Amount total',
	transaction_currency_table_fee_payment: 'Fee payment',
	transaction_currency_table_amount_transaction: 'Transaction amount',
	transaction_currency_table_transaction_currency: 'Transaction currency',
	
	transaction_currency_filter_created_at: 'Transactions Date',
};